/** Subtasking 親子課題の条件 */
export const GET_ISSUE_LIST_PARAMS_SUBTASKING = {
	/** All すべて */
	All: 0,
	/** Exclude Child Issue 子課題以外 */
	ExcludeChildIssue: 1,
	/** Child Issue 子課題 */
	ChildIssue: 2,
	/** Neither Parent Issue nor Child Issue 親課題でも子課題でもない課題 */
	NeitherParentIssueNorChildIssue: 3,
	/** Parent Issue 親課題 */
	ParentIssue: 4,
} as const;

/** Subtasking 親子課題の条件 */
export type GetIssueListParamsSubtasking =
	(typeof GET_ISSUE_LIST_PARAMS_SUBTASKING)[keyof typeof GET_ISSUE_LIST_PARAMS_SUBTASKING];
